import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="berechnung-status"
export default class extends Controller {
	connect() {
		this.abschlussStreamHandler = (event) => this.abschlussStreamAnimieren(event)
		document.addEventListener("turbo:before-stream-render", this.abschlussStreamHandler)

		this.statusAnwenden()
	}

	disconnect() {
		document.removeEventListener("turbo:before-stream-render", this.abschlussStreamHandler)
	}

	statusAnwenden() {
		this.element.dataset.berechnungStatus = this.uiStatus

		if (this.laufend()) enter(this.element)

		// Im nächsten Frame sind auch benachbarte Stimulus-Controller zuverlässig verbunden.
		requestAnimationFrame(() => this.statusEventSenden(this.uiStatus))
	}

	abschlussStreamAnimieren(event) {
		const stream = event.detail?.newStream

		if (!this.abschlussStreamFuerDiesesElement(stream)) return

		const render = event.detail.render

		// Den Abschluss zuerst lokal melden und das Toast ausblenden, bevor Turbo das Element ersetzt.
		event.detail.render = async (streamElement) => {
			this.dispatch("abgeschlossen", { detail: this.eventDetails("abgeschlossen") })
			await leave(this.element)
			await render(streamElement)
		}
	}

	laufend() {
		return this.uiStatus === "laufend"
	}

	statusEventSenden(status) {
		// Lokale Controller können direkt auf berechnung-status:laufend/abgeschlossen reagieren.
		this.dispatch(status, { detail: this.eventDetails(status) })
	}

	abschlussStreamFuerDiesesElement(stream) {
		if (!stream) return false
		if (stream.action !== "replace") return false
		if (stream.target !== this.element.id) return false
		if (!this.laufend()) return false

		return this.streamUiStatus(stream) === "abgeschlossen"
	}

	ziel() {
		return this.element.dataset.berechnungZiel
	}

	streamUiStatus(stream) {
		const status = stream.templateContent.firstElementChild?.dataset?.berechnungStatus
		return status === "laufend" ? "laufend" : "abgeschlossen"
	}

	eventDetails(status) {
		return {
			status,
			ziel: this.ziel(),
			targetId: this.element.id,
		}
	}

	get uiStatus() {
		return this.element.dataset.berechnungStatus === "laufend" ? "laufend" : "abgeschlossen"
	}
}
